import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { Navigate } from 'react-router'

import { Loading } from '../../components'

/*
 * Feature-flag + AI-availability gate for the entire /hey-nic/* subtree. These
 * checks are normally bootstrapped by Main.afterCreate, which does NOT run for a
 * direct load/refresh of the standalone route, so we fetch them here too
 * (idempotent when Main already ran) and fail closed until they resolve.
 */
const HeyNicGate = ({ store, children }) => {
  const { aiStatus, features } = store
  const featuresReady = features.enableHeyNic !== null && features.enableHeyNic !== undefined
  // getAiStatus swallows its own errors (resolves to unavailable), but
  // getFeatures rejects on a failed request — track that so a failed bootstrap
  // fails closed instead of spinning forever.
  const [bootstrapFailed, setBootstrapFailed] = useState(false)

  useEffect(() => {
    if (!aiStatus.initialized) store.getAiStatus()
    if (!featuresReady && !bootstrapFailed) {
      store.getFeatures().catch(err => {
        console.error('[HeyNic] feature bootstrap failed; treating as unavailable:', err)
        setBootstrapFailed(true)
      })
    }
  }, [store, aiStatus.initialized, featuresReady, bootstrapFailed])

  // A failed feature bootstrap fails closed (same as the flag being off).
  if (bootstrapFailed) {
    return <Navigate to='/home' replace />
  }

  // Never render the subtree while the gates are unknown.
  if (!aiStatus.initialized || !featuresReady) {
    return <Loading />
  }

  // Feature off or AI unavailable → bounce home.
  if (!aiStatus.available || !features.enableHeyNic) {
    return <Navigate to='/home' replace />
  }

  return children
}

export default inject('store')(observer(HeyNicGate))
